
import { Link } from 'react-router-dom';
import './ProjectCard.css';

function ProjectCard({ project }) {
  const { period, title, summary, keywords, thumbnail, slug } = project;

  return (
    <Link to={`/projects/${slug}`} className="project-card-link">
      <div className="project-card">
        {/* Left column: image */}
        <div className="project-card-image">
          <img src={thumbnail} alt={title} />
        </div>

        {/* Right column: text */}
        <div className="project-details">
          <div className="project-period">{period}</div>
          <div className="project-title">{title}</div>
          <div className="project-summary">{summary}</div>
          <div className="project-keywords">{keywords.join(' | ')}</div>
        </div>
      </div>
    </Link>
  );
}

export default ProjectCard;